module.exports = __webpack_public_path__ + "img/mine1.afc3f6a8.png";